var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"laycontainer page_wrapper"},[_c('asidebar',{attrs:{"sidebarInfo":_vm.menuInfo}}),_c('mainbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }